<template>
  <div id="content" class="microContent openList">
    <div class="microClassNum" v-show="isShowCount">共{{openList&&openList.length>0?13623:0}}份资源</div>
    <div class="microClassList" style="margin-top: 20px;">
      <Row type="flex" v-if="pageTotal == 0" style="text-align: center;">
        <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt=""></Col>
        <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
      </Row>
      <Row :gutter="27" v-else v-for="(item,index) in openList" :key="index" style="margin-bottom:15px;">
        <Col span="6" v-for="(n,m) in item" :key="m">
        <div class="microBox" @click="toOpenDetail(n.id)">
          <div class="microImgOpenClassBoxOpenClass">
            <img class="microImgOpenClass" :src="imgurl+ n.bimgPath" alt="" >
            <div class="mengBoxOpenClass">
                <img src="/static/images/mengImg.png" alt="" class="meng">
            </div>
          </div>
          <div class="microMsg">
            <div class="microTitle" :title="n.name">{{n.name}}</div>
          </div>
        </div>
        </Col>
      </Row>
    </div>
    <div class="page">
      <Page :total="pageTotal" v-if="pageTotal > 20" :page-size="20" @on-change="changePage" />
    </div>
  </div>
</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    name: 'OpenClassList',
    data() {
      return {
        openList: null, //微课列表  array
        imgurl: 'https://www.aixuetang.com/pic', //微课图片地址  线上域名
        openNum: null, // 微课数量
        pageTotal: null, //总页数
        openGradeId: null, //年级id  通过筛选按钮传过来
        openVersionId: null, //版本id  通过筛选按钮传过来
        openSubjectId: null, //学科id  通过筛选按钮传过来
        documentHeight: '',
        isShowCount:true
      }
    },
    created() {
      const that = this;
      if(that.openGradeId == null && that.openSubjectId == null && that.openVersionId == null){
        this.isShowCount = true;
      }else {
        this.isShowCount = false;
      }
      bus.$on('openGradeId', function(msg) {
        that.openGradeId = msg;
        if(that.openGradeId == null && that.openSubjectId == null && that.openVersionId == null){
          that.isShowCount = true;
        }else {
          that.isShowCount = false;
        }
        //console.log(msg,"openGradeId")
        that.getOpenData(1, that.openGradeId, that.openSubjectId, that.openVersionId);
      })
      bus.$off('openSubjectId');
      bus.$on('openSubjectId', function(msg) {
        that.openSubjectId = msg;
        console.log(msg, "openSubjectId1111111")
        if(that.openGradeId == null && that.openSubjectId == null && that.openVersionId == null){
          that.isShowCount = true;
        }else {
          that.isShowCount = false;
        }
        that.getOpenData(1, that.openGradeId, that.openSubjectId, that.openVersionId);
      })
      bus.$off('openVersionId');
      bus.$on('openVersionId', function(msg) {
        that.openVersionId = msg;
        if(that.openGradeId == null && that.openSubjectId == null && that.openVersionId == null){
          that.isShowCount = true;
        }else {
          that.isShowCount = false;
        }
        //console.log(msg,"openVersionId")
        that.getOpenData(1, that.openGradeId, that.openSubjectId, that.openVersionId);
      })

    },
    mounted() {
      const that = this;
      setTimeout(function() {
        that.getOpenData(1, that.openGradeId, that.openSubjectId, that.openVersionId);
      }, 300)
    },
    updated() {
      // this.documentHeight = this.$refs.ImgBoxWidth0[0].clientWidth * 9 / 16 + 'px'
    },
    methods: {
      //获取公开课程列表
      getOpenData(pageNo, gradeIds, subjectIds, versionId) {
        const websiteId = localStorage.getItem('websiteId')
        const that = this;
        const result = [];
        const url = '/axt-crm/jyxtCourse/pageJyxtCourse';
        if (websiteId == 17) {
          var params = {
            gradeIds: gradeIds,
            subjectIds: subjectIds,
            versionId: versionId,
            gradeIdsNot: [29, 30, 31] + '',
            pageSize: 12,
            pageNo: pageNo,
            websiteId: websiteId
          }
        } else {
          var params = {
            gradeIds: gradeIds,
            subjectIds: subjectIds,
            versionId: versionId,
            pageSize: 20,
            pageNo: pageNo,
            websiteId: websiteId
          }
        }
        //console.log(params, "params")
        api.getListAPI(url, params).then(res => {
          // console.log(res.data)
          if (res.data.success) {
            that.openNum = res.data.data.total; //微课总数量
            that.pageTotal = res.data.data.total; //分页总数
            const openList = res.data.data.rows
            for (let i = 0; i < openList.length; i += 4) {
              result.push(openList.slice(i, i + 4));
            }
            that.openList = result;
            //console.log('microlist',that.openList)
          }else{
              // that.$Message.error(res.data.message);
          }
        })
      },
      //翻页
      changePage(page) {
        const that = this;
        this.getOpenData(page, that.openGradeId, that.openSubjectId, that.openVersionId);
      },
      //跳转详情页
      toOpenDetail(id) {
        this.$emit('isOpenDetail', true);
        this.$nextTick(() => {
          bus.$emit('lessonId', id);

        })
      }
    }
  }
</script>
<style lang="">
  .openList {
    min-height: 600px;
  }

  .emptyImg {
    width: 320px;
    margin-top: 100px;
  }

  .microContent {
    margin-top: 27px !important;
  }

  .microClassNum {
    text-align: left;
    color: #9A9A9A;
    font-size: 14px;
  }
.microImgOpenClass {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .microBox {
    border-radius: 4px;
    overflow: hidden;
  }
  .microBox:hover{
      /* margin-top: -10px; */
      /* position: relative; */
      animation: ImgHover .3s forwards;
      /* box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37); */
  }
  @keyframes ImgHover{
      form{margin-top: 0;box-shadow: 0px 0px 17px 0px rgba(255,255,255,0);}
      to{margin-top:-5px;box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37);}
  }

  .microBox:hover .microTitle {
    color: #3683FF;
  }

  .microImgBoxOpenClass {
    height: 200px;
    /* display: table-cell;
    vertical-align: bottom; */
  }

  .microImgHover {
    display: inline-block;
    border-radius: 10px;
  }

  .microMsg {
    margin-top: 8px;
    /* margin-bottom: 10px; */
  }

  .microTitle {
    font-size: 16px;
    color: #34495E;
    font-weight: 500;
    padding-bottom: 3px;
  }
  /* 蒙版 */
    .microImgOpenClassBoxOpenClass{
        position: relative;
        overflow: hidden;
        height: 157px;
    }
    .openList .mengBoxOpenClass{
        width:100%;
        height: 100%;
        position: absolute;
        left: 0;
        top:0;
        z-index: 10;
        background:rgba(255, 255, 255, 0);
        border-radius: 4px;
    }
    .mengBoxOpenClass img{
        position: absolute;
        left: 50%;
        top: 50%;
        /* transform: translate(-50%,-50%); */
        margin-left: -33px;
        margin-top: -33px;
        opacity: 0;
    }
    .microBox:hover .mengBoxOpenClass{
        animation: mengHovar .3s forwards;
    }
    .microBox:hover .mengBoxOpenClass img{
        animation: mengImgHovar .3s forwards;
    }
    @keyframes mengHovar{
        from {background: rgba(255, 255, 255, 0);}
        to {background: rgba(0, 0, 0, 0.3);}
    }
    @keyframes mengImgHovar{
        from {opacity: 0;transform: scale(2);}
        to {opacity: 1;transform: scale(1);}
    }
</style>



// WEBPACK FOOTER //
// src/components/OpenClassList/OpenClassList.vue